import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-recovery-passwd',
  templateUrl: './recovery-passwd.component.html',
  styleUrls: ['./recovery-passwd.component.sass']
})
export class RecoveryPasswdComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
